/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {CRUDPermissions, DownloadJob, DownloadJobType} from '@ion/core/src/types/entities';
import {StopActionRowButton} from '@ion/dls/src/components/buttons/StopActionRowButton';
import {cancelTasks} from '@/store/actions/downloadjobs';

export interface CancelTaskType {
  task: DownloadJob;
  downloadjobs: DownloadJob;
  index: number;
  jobsPermissions?: CRUDPermissions;
}

export const CancelTask = ({task, downloadjobs, index, jobsPermissions}: CancelTaskType) => {
  const dispatch = useDispatch();

  function cancelTask() {
    if (!isPending) {
      dispatch(cancelTasks(downloadjobs, index));
    }
  };

  const isDisabled = useMemo(() => {
    const progressStatus = task?.progressStatus;
    return (
      progressStatus === DownloadJobType.Completed ||
      progressStatus === DownloadJobType.Failed ||
      progressStatus === DownloadJobType.Cancelled ||
      progressStatus === DownloadJobType.Cancelling
    );
  }, [task]);

  const isPending = useMemo(() => {
    const progressStatus = task?.progressStatus;
    return progressStatus === DownloadJobType.Pending;
  }, [task]);

  return (
    <>
      {!isDisabled
        ? (<StopActionRowButton onClick={cancelTask}
          tooltipCaption={isPending
            ? translate('downloadjobs:canclePendingJobTooltip')
            : translate('common:tooltips.cancelEntity', {entity: translate('common:entityLabels.task')})}
          isDisabled={isDisabled || !jobsPermissions?.hasDeletePermission}
          isPending={isPending} />
        ) : null
      }
    </>
  );
};

export default CancelTask;
